import React from 'react';
import { CheckCircle2 } from 'lucide-react';

function renderTip(tip) {
  const match = tip.match(/^([\s\S]+?at:\s+)([\w.-]+(?:\/[\w._/-]*)?)(\s*)$/);
  if (match) {
    const url = match[2];
    return (
      <span>
        {match[1]}
        <a
          href={`https://${url}`}
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-orange-700 hover:text-orange-900 break-all"
        >
          {url}
        </a>
        {match[3]}
      </span>
    );
  }
  return tip;
}

export function HelpTips({ items }) {
  return (
    <div className="bg-orange-50 border border-orange-100 rounded-xl p-5 my-4">
      <p className="text-sm font-semibold text-orange-800 mb-3">Tips & Best Practices</p>
      <ul className="space-y-2">
        {items.map((tip, i) => (
          <li key={i} className="flex items-start gap-2.5 text-sm text-orange-900">
            <CheckCircle2 size={15} className="flex-shrink-0 text-orange-500 mt-0.5" />
            <span>{renderTip(tip)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
